export default function Markdown({ text }) {
    const lines = (text || "").split("\n");
    const blocks = [];
    let list = null;

    const inline = (s) =>
        s.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((part, i) => {
            if (part.startsWith("**") && part.endsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
            if (part.startsWith("`") && part.endsWith("`"))
                return <code key={i} className="bg-slate-200/70 dark:bg-white/10 rounded px-1 text-[0.85em] font-data">{part.slice(1, -1)}</code>;
            return part;
        });

    lines.forEach((line, i) => {
        const trimmed = line.trim();
        if (trimmed.startsWith("- ") || trimmed.startsWith("* ")) {
            if (!list) {
                list = [];
                blocks.push({ type: "ul", items: list, key: i });
            }
            list.push(trimmed.slice(2));
        } else {
            list = null;
            if (!trimmed) return;
            const h = trimmed.match(/^(#{1,4})\s+(.*)/);
            if (h) blocks.push({ type: "h", level: h[1].length, text: h[2], key: i });
            else if (/^\d+\.\s/.test(trimmed)) blocks.push({ type: "p", text: trimmed, key: i });
            else blocks.push({ type: "p", text: trimmed, key: i });
        }
    });

    return (
        <div>
            {blocks.map((b) => {
                if (b.type === "ul")
                    return (
                        <ul key={b.key}>
                            {b.items.map((it, j) => (
                                <li key={j}>{inline(it)}</li>
                            ))}
                        </ul>
                    );
                if (b.type === "h") {
                    const Tag = `h${Math.min(b.level + 2, 6)}`;
                    return <Tag key={b.key} className="text-sm">{inline(b.text)}</Tag>;
                }
                return <p key={b.key}>{inline(b.text)}</p>;
            })}
        </div>
    );
}
